import './index.scss'

/* import Swiper core, modules, and css */
import Swiper from 'swiper';
import { Navigation, Scrollbar, Parallax, Manipulation } from 'swiper/modules'; // import Swiper modules (when needed). Full list available here: https://swiperjs.com/swiper-api#modules
import { toggleSwiperLock } from './../../js/toggleSwiperLock'
import { useChapters } from './../../js/useChapters'
import { getTPID } from './../../js/thematic-path.js'

/* global fetch */
class Slider {
  constructor(el) {
    this.$el = el
    
    // console.log('Slider::constructor')
  }
  async init() {
    // console.log('Slider::init')
    
    if (this.$el.classList.contains('oce-slider--skeleton')) {
      this._$parent = this.$el.parentElement
      // console.log(this.$el)
      // console.log(this._$parent)
      // console.log('skeleton slider detected')
      await this.queryCards()
      this.$el = this._$parent.children[0]
      // console.log(this.$el)
      // console.log('skeleton slider populated.')
    } 
    
    this.initSwiper()
    
    if (this.$el.querySelector('.oce-slider__chapter')) {
      this.initChapters()
    }
  }
  initSwiper() {
    // console.log('::initSwiper')
    const swiperModules = [Navigation, Scrollbar]
    
    const cardType = this.$el.dataset.cardType
    if (cardType === 'project') swiperModules.push(Parallax)
    
    if (false) swiperModules.push(Manipulation) // TODO: if chapters detected
    
    const eventCallbacksObj = {
      init: function(swiper) {
        const margins = cardType === 'project' ? 48 * 2 : 0 // TODO: account for padding (at least for project-slider )
        return toggleSwiperLock(swiper, margins)
      },
      // click: function (swiper) {
      //   swiper.slideTo(this.clickedIndex, 1000)  
      // },
      resize: function(swiper) {
        const margins = cardType === 'project' ? 48 * 2 : 0 // TODO: account for padding (at least for project-slider )
        return toggleSwiperLock(swiper, margins)
      },
      /*progress: function(swiper, progress) {
        console.log(progress)
      },*/
    }
    
    const $el = this.$el
    if (cardType === 'project') {
      eventCallbacksObj.slideChange = function(swiper) {
        const bgs = [ ...$el.querySelectorAll('.parallax-bgg') ]
        bgs[swiper.activeIndex].style.opacity = 1
        bgs[swiper.previousIndex].style.opacity = 0
      }
    }
    
    this.swiper = new Swiper(this.$el.querySelector('.oce-slider__swiper'), {
      slidesPerView: 'auto',
      modules: swiperModules,
      grabCursor: true,
      // setWrapperSize: (cardType === 'project'),
      setWrapperSize: true,
      
      navigation: {
        prevEl: '[data-swiper-prev]',
        nextEl: '[data-swiper-next]',
      },
      
      scrollbar: {
        draggable: false,
        hide: false,
        el: '[data-swiper-scrollbar]'
      },
      
      parallax: (cardType === 'project'),
      centeredSlides: false,
      
      spaceBetween: 16,
      
      breakpoints: {
        992: {
          spaceBetween: 24,
          centeredSlides: (cardType === 'project') && !this.$el.parentElement.classList.contains('resource-sheet'),
        }
      },
      
      on: eventCallbacksObj,
      preventClicks: true,
      slideToClickedSlide: false,
    })
  }
  initChapters() {
    // console.log('::initChapters')
    useChapters(this.$el, this.$el.querySelector('[data-chapters-swiper]'))
  }
  
  buildQuery() {
    const url = new URL(`${document.location.origin}/wp-json/oce/v1/resource_bottom_slider/`)
    const lang = document.documentElement.lang.slice(0, 2)
    const tpid = getTPID()
    const rid = parseInt(document.querySelector('main').dataset.rid)
    
    // console.log('gonna send', lang, tpid, rid)
    url.searchParams.append('lang', lang)
    url.searchParams.append('tpid', tpid)
    url.searchParams.append('rid', rid)
    
    console.log('request:', url.href)
    
    return url
  }
  async betterFetch(url) {
    return fetch(url)
      .then(response => {
        if (response.ok) return response.json()
        else {
          /* An error has occured */
          return response.json()
            .catch(() => {
              /* Couldn't parse the JSON */
              return response.status
            })
            .then(({message}) => {
              /* Got valid JSON with error response, use it */
              console.error(`Got valid JSON with error response "${message || response.status}". (URL: ${url})`)
              // throw new Error(message || response.status);
              return {httpCode: response.status, errorMessage: message}
            })
        }
      })
      .catch(error => error)
  }
  async queryCards() {
    const url = this.buildQuery()
    const response = await this.betterFetch(url)
    // console.log('response:', response)
    this.$el.parentElement.innerHTML = response.data
  }
}

document.addEventListener('DOMContentLoaded', () => {
    [ ...document.querySelectorAll('.oce-slider') ].forEach($block => {
        $block.expandygg = new Slider($block)
    })
}, {capture: false, passive: true, once: true} || false)
